import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import Rentals from "@/pages/Rentals";

export const Route = createFileRoute("/rentals")({
  head: () => pageHead({
    title: 'RV Rentals',
    description: 'Rent a travel trailer or motorhome from Rex & Sons RVs near Wilmington, NC — clean, late-model RVs for your next trip.',
    path: '/rentals',
  }),
  component: Rentals,
});
